import { useEffect } from 'react';

// Generic component for tab navigation using left/right arrow keys
const TabKeyNavigationHandler = ({
  availableTabs,
  currentTab,
  onTabChange
}) => {
  useEffect(() => {
    const handleTabKeyNavigation = event => {
      if (!availableTabs || availableTabs.length === 0) {
        return;
      }

      const activeElement = document.activeElement;
      if (
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.isContentEditable)
      ) {
        return;
      }

      const currentIndex = availableTabs.findIndex(tab => tab === currentTab);
      if (currentIndex === -1) {
        return;
      }

      if (event.key === 'ArrowRight' || event.keyCode === 39) {
        if (currentIndex < availableTabs.length - 1) {
          const nextTab = availableTabs[currentIndex + 1];
          if (nextTab) {
            onTabChange(nextTab);
          }
        }
      } else if (event.key === 'ArrowLeft' || event.keyCode === 37) {
        if (currentIndex > 0) {
          const prevTab = availableTabs[currentIndex - 1];
          if (prevTab) {
            onTabChange(prevTab);
          }
        }
      }
    };

    document.addEventListener('keydown', handleTabKeyNavigation);

    return () => {
      document.removeEventListener('keydown', handleTabKeyNavigation);
    };
  }, [availableTabs, currentTab, onTabChange]);

  return null;
};

export default TabKeyNavigationHandler;
